import state from "./moduleOptimizationState.js";
import mutations from "./moduleOptimizationMutations.js";
import actions from "./moduleOptimizationActions.js";
import getters from "./moduleOptimizationGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
